import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {GridComponent, GridDataResult, SelectableSettings, SortSettings} from "@progress/kendo-angular-grid";
import {orderBy, SortDescriptor} from "@progress/kendo-data-query";
import {SettingsCashregService} from "./settings-cashreg.service";
import {DtoArticleList} from "./models/DtoArticleList";
import {DtoTreatmentList} from "./models/DtoTreatmentList";
import {DtoDiscountList} from "./models/DtoDiscountList";
import {DtoQuantityDiscountList} from "./models/DtoQuantityDiscountList";
import {DtoGiftCertificateList} from "./models/DtoGiftCertificateList";
import {DtoCureCreditList} from "./models/DtoCureCreditList";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ArticleComponent} from "./article.component";
import {SharedService} from "../../shared/shared.service";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {TreatmentComponent} from "./treatment.component";
import {TreatmentCombinationComponent} from "./treatment-combination.component";
import {DtoTreatmentListResult} from "./models/DtoTreatmentListResult";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DiscountComponent} from "./discount.component";
import {QuantityDiscountComponent} from "./quantity-discount.component";
import {GiftcertificateComponent} from "./giftcertificate.component";
import {CurecreditComponent} from "./curecredit.component";
import {ArticlePriceChangeComponent} from "./article-price-change.component";
import {TreatmentPriceChangeComponent} from "./treatment-price-change.component";
import {DtoSubscriptionTypeList} from "./models/DtoSubscriptionTypeList";
import {SubscriptionTypeComponent} from "./subscription-type.component";

@Component({
    selector: 'app-settings-cashreg',
    template: require('./settings-cashreg.component.html'),
    styles: [require('./settings-cashreg.component.css')]
})

@AutoUnsubscribe()
export class SettingsCashregComponent implements OnInit {
    @ViewChild('gridArticles', {static: false}) gridArticles: DynamicGridComponent;
    @ViewChild('gridTreatments', {static: false}) gridTreatments: GridComponent;
    @ViewChild('gridDiscounts', {static: false}) gridDiscounts: GridComponent;
    @ViewChild('gridQuantityDiscounts', {static: false}) gridQuantityDiscounts: GridComponent;
    @ViewChild('gridGiftCertificates', {static: false}) gridGiftCertificates: GridComponent;
    @ViewChild('gridCureCredits', {static: false}) gridCureCredits: GridComponent;
    @ViewChild('gridSubscription', {static: false}) gridSubscription: GridComponent;
    filterHeaderConfig: PageHeaderBarConfig;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    selectableSettings: SelectableSettings = {
        checkboxOnly: false,
        enabled: true,
        mode: "single"
    };
    sortableSettings: SortSettings = {
        mode: 'single',
        allowUnsort: false
    };

    articleFilterForm: FormGroup;
    pshbArticleConfig: PageSubheaderBarConfig;
    articleData: DtoArticleList[];
    articleColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPriceIn',
            label: 'Prijs (in)',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'retailPriceEx',
            label: 'Prijs (ex)',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'cashregGroup',
            label: 'Kassagroep',
            type: 'string',
            width: '150px'
        },
        {
            key: 'cashregSubgroup',
            label: 'Kassasubgroep',
            type: 'string',
            width: '160px'
        },
        {
            key: 'salesGroup',
            label: 'Omzetgroep',
            type: 'string',
            width: '150px'
        },
        {
            key: 'salesSubgroup',
            label: 'Omzetsubgroep',
            type: 'string',
            width: '160px'
        },
        {
            key: 'department',
            label: 'Afdeling',
            type: 'string',
            width: '150px'
        },
        {
            key: 'isActive',
            label: 'Actief',
            type: 'boolean',
            width: '100px'
        }
    ];

    treatmentFilterForm: FormGroup;
    pshbTreatmentConfig: PageSubheaderBarConfig;
    selectedTreatmentIds: number[] = [];
    treatmentGridSort: SortDescriptor[] = [];
    treatmentGridView: GridDataResult;
    treatmentData: DtoTreatmentList[];

    discountFilterForm: FormGroup;
    pshbDiscountConfig: PageSubheaderBarConfig;
    selectedDiscountIds: number[] = [];
    discountGridSort: SortDescriptor[] = [];
    discountGridView: GridDataResult;
    discountData: DtoDiscountList[];

    phbQuantityDiscountConfig: PageHeaderBarConfig;
    selectedQuantityDiscountIds: number[] = [];
    quantityDiscountGridSort: SortDescriptor[] = [];
    quantityDiscountGridView: GridDataResult;
    quantityDiscountData: DtoQuantityDiscountList[];

    giftCertificateFilterForm: FormGroup;
    pshbGiftCertificateConfig: PageSubheaderBarConfig;
    selectedGiftCertificateIds: number[] = [];
    giftCertificateGridSort: SortDescriptor[] = [];
    giftCertificateGridView: GridDataResult;
    giftCertificateData: DtoGiftCertificateList[];

    cureCreditFilterForm: FormGroup;
    pshbCureCreditConfig: PageSubheaderBarConfig;
    selectedCureCreditIds: number[] = [];
    cureCreditGridSort: SortDescriptor[] = [];
    cureCreditGridView: GridDataResult;
    cureCreditData: DtoCureCreditList[];

    subscriptionFilterForm: FormGroup;
    pshbSubscriptionConfig: PageSubheaderBarConfig;
    selectedSubscriptionIds: number[] = [];
    subscriptionGridSort: SortDescriptor[] = [];
    subscriptionGridView: GridDataResult;
    subscriptionData: DtoSubscriptionTypeList[];

    hasBtwZero: boolean;

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private dialogService: DialogService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'instellingen', isLastStep: false },
            { text: 'kassa instellingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'ZOEKOPTIES',
            buttonDefinition: [
                {
                    description: 'ZOEKEN',
                    clickEventType: 'search',
                    isSmall: false
                },
                {
                    description: 'WISSEN',
                    clickEventType: 'clear',
                    isSmall: false
                }
            ]
        };

        this.articleFilterForm = this.fb.group({
            description: '',
            index: '',
            barcode: '',
            showInactive: false
        });
        this.pshbArticleConfig = {
            title: 'ARTIKELEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                },
                {
                    clickEventType: 'priceChange',
                    description: 'PRIJS WIJZIGINGEN',
                    isSmall: false
                }
            ]
        };

        this.treatmentFilterForm = this.fb.group({
            description: '',
            index: '',
            showInactive: false
        });
        this.pshbTreatmentConfig = {
            title: 'BEHANDELINGEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'createCombination',
                    description: 'COMBINATIE',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                },
                {
                    clickEventType: 'priceChange',
                    description: 'PRIJS WIJZIGINGEN',
                    isSmall: false
                }
            ]
        };

        this.discountFilterForm = this.fb.group({
            description: '',
            index: '',
            showInactive: false
        });
        this.pshbDiscountConfig = {
            title: 'KORTINGEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.phbQuantityDiscountConfig = {
            title: 'STAFFELKORTINGEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.giftCertificateFilterForm = this.fb.group({
            description: '',
            index: '',
            showInactive: false
        });
        this.pshbGiftCertificateConfig = {
            title: 'KADOBONNEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.cureCreditFilterForm = this.fb.group({
            description: '',
            index: '',
            showInactive: false
        });
        this.pshbCureCreditConfig = {
            title: 'KUREN/TEGOED',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.subscriptionFilterForm = this.fb.group({
            description: '',
            showInactive: false
        });
        this.pshbSubscriptionConfig = {
            title: 'ABONNEMENTEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.ds.getArticleBaseItems(true).subscribe();
        this.ds.getTreatmentBaseItems(true).subscribe();
        this.ds.getDiscountBaseItems(true).subscribe();
    }

    ngAfterViewInit() {
        this.loadArticles(false);
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadArticles(false);
        } else if (e.index == 1) {
            this.loadTreatments(false);
        } else if (e.index == 2) {
            this.loadDiscounts(false);
        } else if (e.index == 3) {
            this.loadQuantityDiscounts(false);
        } else if (e.index == 4) {
            this.loadGiftCertificates(false);
        } else if (e.index == 5) {
            this.loadCureCredits(false);
        } else if (e.index == 6) {
            this.loadSubscriptions(false);
        }
    }

    // ARTICLE
    loadArticles(reload: boolean) {
        if (reload || !this.articleData) {
            this.ds.getArticles().subscribe((res: DtoArticleList[]) => {
                this.articleData = res;
                this.filterArticles();
            });
        }
    }

    filterArticles() {
        let filteredData = this.articleData;

        if (!this.articleFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.articleFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.articleFilterForm.get('description').value.toLowerCase()));
        }
        if (this.articleFilterForm.get('index').value > 0) {
            filteredData = filteredData.filter(x => x.index == this.articleFilterForm.get('index').value);
        }

        if (this.articleFilterForm.get('barcode').value) {
            filteredData = filteredData.filter(x => x.barcode.toLowerCase() == this.articleFilterForm.get('barcode').value.toLowerCase());
        }

        this.gridArticles.showData(filteredData);
    }

    phbArticleBtnClicked(event) {
        if (event == 'search') {
            this.filterArticles();
        } else if (event == 'clear') {
            this.articleFilterForm.reset({ showInactive: false });
            this.filterArticles();
        }
    }

    pshbArticleBtnClicked(event) {
        if (event == 'create') {
            this.showArticleEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.gridArticles.getSelectedId() > 0) {
                this.showArticleEditWindow(this.gridArticles.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.gridArticles.getSelectedId() > 0) {
                this.showArticleEditWindow(0, this.gridArticles.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.gridArticles.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteArticleById(this.gridArticles.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadArticles(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        } else if (event == 'priceChange') {
            this.showArticlePriceChangeWindow();
        }
    }

    gridArticleRowdoubleClicked(event) {
        if (this.gridArticles.getSelectedId() > 0) {
            this.showArticleEditWindow(this.gridArticles.getSelectedId(), 0);
        }
    }

    showArticleEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: ArticleComponent
        });

        const dialogContent: ArticleComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadArticles(true);
                }
            });
    }

    showArticlePriceChangeWindow() {
        const dialogRef = this.dialogService.open({
            content: ArticlePriceChangeComponent
        });

        const dialogContent: ArticlePriceChangeComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadArticles(true);
                }
            });
    }

    // TREATMENT
    loadTreatments(reload: boolean) {
        if (reload || !this.treatmentData) {
            this.ds.getTreatments().subscribe((res: DtoTreatmentListResult) => {
                this.treatmentData = res.treatments;
                this.hasBtwZero = res.hasBtwZero;
                this.selectedTreatmentIds = [];
                this.filterTreatments();
            });
        }
    }

    treatmentGridSortChange(sort: SortDescriptor[]): void {
        this.treatmentGridSort = sort;
        this.filterTreatments();
    }

    filterTreatments() {
        let filteredData = this.treatmentData;

        if (!this.treatmentFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.treatmentFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.treatmentFilterForm.get('description').value.toLowerCase()));
        }
        if (this.treatmentFilterForm.get('index').value > 0) {
            filteredData = filteredData.filter(x => x.index == this.treatmentFilterForm.get('index').value);
        }

        this.treatmentGridView = {
            data: orderBy(filteredData, this.treatmentGridSort),
            total: filteredData.length
        };
    }

    phbTreatmentBtnClicked(event) {
        if (event == 'search') {
            this.filterTreatments();
        } else if (event == 'clear') {
            this.treatmentFilterForm.reset({ showInactive: false });
            this.filterTreatments();
        }
    }

    getSelectedTreatmentId(): number {
        if (this.selectedTreatmentIds.length == 1)
            return this.selectedTreatmentIds[0];
        return 0;
    }

    treatmentIsCombi(id: number) {
        if (this.treatmentData) {
            let item = this.treatmentData.find(x => x.id == id);
            if (item) {
                return item.isCombi;
            }
        }

        return false;
    }

    pshbTreatmentBtnClicked(event) {
        if (event == 'create') {
            this.showTreatmentEditWindow(0, 0);
        } else if (event == 'createCombination') {
            if (this.hasBtwZero) {
                this.showTreatmentCombinationEditWindow(0, 0);
            } else {
                this.ss.message('Er is geen BTW 0% gevonden. Deze BTW groep is nodig om een combinatiebehandeling aan te maken.');
            }
        } else if (event == 'edit') {
            if (this.getSelectedTreatmentId() > 0) {
                if (this.treatmentIsCombi(this.getSelectedTreatmentId())) {
                    this.showTreatmentCombinationEditWindow(this.getSelectedTreatmentId(), 0);
                } else {
                    this.showTreatmentEditWindow(this.getSelectedTreatmentId(), 0);
                }
            }
        } else if (event == 'copy') {
            if (this.getSelectedTreatmentId() > 0) {
                if (this.treatmentIsCombi(this.getSelectedTreatmentId())) {
                    this.showTreatmentCombinationEditWindow(0, this.getSelectedTreatmentId());
                } else {
                    this.showTreatmentEditWindow(0, this.getSelectedTreatmentId());
                }
            }
        } else if (event == 'delete') {
            if (this.getSelectedTreatmentId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteTreatmentById(this.getSelectedTreatmentId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadTreatments(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        } else if (event == 'priceChange') {
            this.showTreatmentPriceChangeWindow();
        }
    }

    gridTreatmentRowdoubleClicked(event) {
        if (this.getSelectedTreatmentId() > 0) {
            if (this.treatmentIsCombi(this.getSelectedTreatmentId())) {
                this.showTreatmentCombinationEditWindow(this.getSelectedTreatmentId(), 0);
            } else {
                this.showTreatmentEditWindow(this.getSelectedTreatmentId(), 0);
            }
        }
    }

    showTreatmentEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: TreatmentComponent
        });

        const dialogContent: TreatmentComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadTreatments(true);
                }
            });
    }

    showTreatmentCombinationEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: TreatmentCombinationComponent
        });

        const dialogContent: TreatmentCombinationComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadTreatments(true);
                }
            });
    }

    showTreatmentPriceChangeWindow() {
        const dialogRef = this.dialogService.open({
            content: TreatmentPriceChangeComponent
        });

        const dialogContent: TreatmentPriceChangeComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadTreatments(true);
                }
            });
    }

    // DISCOUNT
    loadDiscounts(reload: boolean) {
        if (reload || !this.discountData) {
            this.ds.getDiscounts().subscribe((res: DtoDiscountList[]) => {
                this.discountData = res;
                this.selectedDiscountIds = [];
                this.filterDiscounts();
            });
        }
    }

    discountGridSortChange(sort: SortDescriptor[]): void {
        this.discountGridSort = sort;
        this.filterDiscounts();
    }

    filterDiscounts() {
        let filteredData = this.discountData;

        if (!this.discountFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.discountFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.discountFilterForm.get('description').value.toLowerCase()));
        }
        if (this.discountFilterForm.get('index').value > 0) {
            filteredData = filteredData.filter(x => x.index == this.discountFilterForm.get('index').value);
        }

        this.discountGridView = {
            data: orderBy(filteredData, this.discountGridSort),
            total: filteredData.length
        };
    }

    phbDiscountBtnClicked(event) {
        if (event == 'search') {
            this.filterDiscounts();
        } else if (event == 'clear') {
            this.discountFilterForm.reset({ showInactive: false });
            this.filterDiscounts();
        }
    }

    pshbDiscountBtnClicked(event) {
        if (event == 'create') {
            this.showDiscountEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.getSelectedDiscountId() > 0) {
                this.showDiscountEditWindow(this.getSelectedDiscountId(), 0);
            }
        } else if (event == 'copy') {
            if (this.getSelectedDiscountId() > 0) {
                this.showDiscountEditWindow(0, this.getSelectedDiscountId());
            }
        } else if (event == 'delete') {
            if (this.getSelectedDiscountId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteDiscountById(this.getSelectedDiscountId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadDiscounts(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    getSelectedDiscountId(): number {
        if (this.selectedDiscountIds.length == 1)
            return this.selectedDiscountIds[0];
        return 0;
    }

    gridDiscountRowdoubleClicked(event) {
        if (this.getSelectedDiscountId() > 0) {
            this.showDiscountEditWindow(this.getSelectedDiscountId(), 0);
        }
    }

    showDiscountEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: DiscountComponent
        });

        const dialogContent: DiscountComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadDiscounts(true);
                }
            });
    }

    // QUANTITYDISCOUNT
    loadQuantityDiscounts(reload: boolean) {
        if (reload || !this.quantityDiscountData) {
            this.ds.getQuantityDiscounts().subscribe((res: DtoQuantityDiscountList[]) => {
                this.quantityDiscountData = res;
                this.selectedQuantityDiscountIds = [];
                this.filterQuantityDiscounts();
            });
        }
    }

    quantityDiscountGridSortChange(sort: SortDescriptor[]): void {
        this.quantityDiscountGridSort = sort;
        this.filterQuantityDiscounts();
    }

    filterQuantityDiscounts() {
        this.quantityDiscountGridView = {
            data: orderBy(this.quantityDiscountData, this.quantityDiscountGridSort),
            total: this.quantityDiscountData.length
        };
    }

    getSelectedQuantityDiscountId(): number {
        if (this.selectedQuantityDiscountIds.length == 1)
            return this.selectedQuantityDiscountIds[0];
        return 0;
    }

    phbQuantityDiscountBtnClicked(event) {
        if (event == 'create') {
            this.showQuantityDiscountEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.getSelectedQuantityDiscountId() > 0) {
                this.showQuantityDiscountEditWindow(this.getSelectedQuantityDiscountId(), 0);
            }
        } else if (event == 'copy') {
            if (this.getSelectedQuantityDiscountId() > 0) {
                this.showQuantityDiscountEditWindow(0, this.getSelectedQuantityDiscountId());
            }
        } else if (event == 'delete') {
            if (this.getSelectedQuantityDiscountId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteQuantityDiscountById(this.getSelectedQuantityDiscountId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadQuantityDiscounts(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridQuantityDiscountRowdoubleClicked(event) {
        if (this.getSelectedQuantityDiscountId() > 0) {
            this.showQuantityDiscountEditWindow(this.getSelectedQuantityDiscountId(), 0);
        }
    }

    showQuantityDiscountEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: QuantityDiscountComponent
        });

        const dialogContent: QuantityDiscountComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadQuantityDiscounts(true);
                }
            });
    }

    // GIFTCERTIFICATE
    loadGiftCertificates(reload: boolean) {
        if (reload || !this.giftCertificateData) {
            this.ds.getGiftCertificates().subscribe((res: DtoGiftCertificateList[]) => {
                this.giftCertificateData = res;
                this.selectedGiftCertificateIds = [];
                this.filterGiftCertificates();
            });
        }
    }

    giftCertificateGridSortChange(sort: SortDescriptor[]): void {
        this.giftCertificateGridSort = sort;
        this.filterGiftCertificates();
    }

    filterGiftCertificates() {
        let filteredData = this.giftCertificateData;

        if (!this.giftCertificateFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.giftCertificateFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.giftCertificateFilterForm.get('description').value.toLowerCase()));
        }
        if (this.giftCertificateFilterForm.get('index').value > 0) {
            filteredData = filteredData.filter(x => x.index == this.giftCertificateFilterForm.get('index').value);
        }

        this.giftCertificateGridView = {
            data: orderBy(filteredData, this.giftCertificateGridSort),
            total: filteredData.length
        };
    }

    phbGiftCertificateBtnClicked(event) {
        if (event == 'search') {
            this.filterGiftCertificates();
        } else if (event == 'clear') {
            this.giftCertificateFilterForm.reset({ showInactive: false });
            this.filterGiftCertificates();
        }
    }

    getSelectedGiftCertificateId(): number {
        if (this.selectedGiftCertificateIds.length == 1)
            return this.selectedGiftCertificateIds[0];
        return 0;
    }

    pshbGiftCertificateBtnClicked(event) {
        if (event == 'create') {
            this.showGiftCertificateEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.getSelectedGiftCertificateId() > 0) {
                this.showGiftCertificateEditWindow(this.getSelectedGiftCertificateId(), 0);
            }
        } else if (event == 'copy') {
            if (this.getSelectedGiftCertificateId() > 0) {
                this.showGiftCertificateEditWindow(0, this.getSelectedGiftCertificateId());
            }
        } else if (event == 'delete') {
            if (this.getSelectedGiftCertificateId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteGiftCertificateById(this.getSelectedGiftCertificateId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadGiftCertificates(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridGiftCertificateRowdoubleClicked(event) {
        if (this.getSelectedGiftCertificateId() > 0) {
            this.showGiftCertificateEditWindow(this.getSelectedGiftCertificateId(), 0);
        }
    }

    showGiftCertificateEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: GiftcertificateComponent
        });

        const dialogContent: GiftcertificateComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadGiftCertificates(true);
                }
            });
    }

    // CURECREDIT
    loadCureCredits(reload: boolean) {
        if (reload || !this.cureCreditData) {
            this.ds.getCureCredits().subscribe((res: DtoCureCreditList[]) => {
                this.cureCreditData = res;
                this.selectedCureCreditIds = [];
                this.filterCureCredits();
            });
        }
    }

    cureCreditGridSortChange(sort: SortDescriptor[]): void {
        this.cureCreditGridSort = sort;
        this.filterCureCredits();
    }

    filterCureCredits() {
        let filteredData = this.cureCreditData;

        if (!this.cureCreditFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.cureCreditFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.cureCreditFilterForm.get('description').value.toLowerCase()));
        }
        if (this.cureCreditFilterForm.get('index').value > 0) {
            filteredData = filteredData.filter(x => x.index == this.cureCreditFilterForm.get('index').value);
        }

        this.cureCreditGridView = {
            data: orderBy(filteredData, this.cureCreditGridSort),
            total: filteredData.length
        };
    }

    phbCureCreditBtnClicked(event) {
        if (event == 'search') {
            this.filterCureCredits();
        } else if (event == 'clear') {
            this.cureCreditFilterForm.reset({ showInactive: false });
            this.filterCureCredits();
        }
    }

    getSelectedCureCreditId(): number {
        if (this.selectedCureCreditIds.length == 1)
            return this.selectedCureCreditIds[0];
        return 0;
    }

    pshbCureCreditBtnClicked(event) {
        if (event == 'create') {
            this.showCureCreditEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.getSelectedCureCreditId() > 0) {
                this.showCureCreditEditWindow(this.getSelectedCureCreditId(), 0);
            }
        } else if (event == 'copy') {
            if (this.getSelectedCureCreditId() > 0) {
                this.showCureCreditEditWindow(0, this.getSelectedCureCreditId());
            }
        } else if (event == 'delete') {
            if (this.getSelectedCureCreditId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteCureCreditById(this.getSelectedCureCreditId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadCureCredits(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridCureCreditRowdoubleClicked(event) {
        if (this.getSelectedCureCreditId() > 0) {
            this.showCureCreditEditWindow(this.getSelectedCureCreditId(), 0);
        }
    }

    showCureCreditEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: CurecreditComponent
        });

        const dialogContent: CurecreditComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadCureCredits(true);
                }
            });
    }

    // SUBSCRIPTIONS
    loadSubscriptions(reload: boolean) {
        this.ds.getSubscriptionTypeBaseItems(true).subscribe();
        this.ds.getSubscriptionTypeTreatmentsToUse(true).subscribe();
        if (reload || !this.cureCreditData) {
            this.ds.getSubscriptionTypes().subscribe((res: DtoSubscriptionTypeList[]) => {
                this.subscriptionData = res;
                this.selectedSubscriptionIds = [];
                this.filterSubscriptions();
            });
        }
    }

    subscriptionGridSortChange(sort: SortDescriptor[]): void {
        this.subscriptionGridSort = sort;
        this.filterSubscriptions();
    }

    filterSubscriptions() {
        let filteredData = this.subscriptionData;

        if (!this.subscriptionFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }
        if (this.subscriptionFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.subscriptionFilterForm.get('description').value.toLowerCase()));
        }

        this.subscriptionGridView = {
            data: orderBy(filteredData, this.subscriptionGridSort),
            total: filteredData.length
        };
    }

    phbSubscriptionBtnClicked(event) {
        if (event == 'search') {
            this.filterSubscriptions();
        } else if (event == 'clear') {
            this.subscriptionFilterForm.reset({ showInactive: false });
            this.filterSubscriptions();
        }
    }

    getSelectedSubscriptionId(): number {
        if (this.selectedSubscriptionIds.length == 1)
            return this.selectedSubscriptionIds[0];
        return 0;
    }

    pshbSubscriptionBtnClicked(event) {
        if (event == 'create') {
            this.showSubscriptionEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.getSelectedSubscriptionId() > 0) {
                this.showSubscriptionEditWindow(this.getSelectedSubscriptionId(), 0);
            }
        } else if (event == 'copy') {
            if (this.getSelectedSubscriptionId() > 0) {
                this.showSubscriptionEditWindow(0, this.getSelectedSubscriptionId());
            }
        } else if (event == 'delete') {
            if (this.getSelectedSubscriptionId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteSubscriptionTypeById(this.getSelectedSubscriptionId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadSubscriptions(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridSubscriptionRowdoubleClicked(event) {
        if (this.getSelectedSubscriptionId() > 0) {
            this.showSubscriptionEditWindow(this.getSelectedSubscriptionId(), 0);
        }
    }

    showSubscriptionEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: SubscriptionTypeComponent
        });

        const dialogContent: SubscriptionTypeComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadSubscriptions(true);
                }
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/settings-cashreg.component.ts